import * as React from "react";

import { isDevelopment } from "@/config/environmentUtils";

// the library should NEVER be used in production because it slows down React
if (isDevelopment()) {
  // Issue #243: Doesn't work with Vite + React
  // https://github.com/welldone-software/why-did-you-render/issues/243
  const { default: whyDidYouRender } =
    await import("@welldone-software/why-did-you-render");

  whyDidYouRender(React, {
    trackHooks: true,
    trackAllPureComponents: false,
    titleColor: "brown",
  });
}
